import { useEffect, useState } from 'react';
import { useBetsStore } from '../lib/store';
import styles from './Bets.module.css';

export default function Bets() {
	const { bets, isLoading, error, fetchBets } = useBetsStore();
	const [filter, setFilter] = useState<string>('all');

	useEffect(() => {
		fetchBets();
	}, [fetchBets]);

	const filteredBets = bets.filter((bet) => {
		if (filter === 'all') return true;
		if (filter === 'wins') return bet.won;
		if (filter === 'losses') return !bet.won;
		return bet.game.toLowerCase() === filter;
	});

	if (isLoading && !bets.length) {
		return (
			<div className={styles.loading}>
				<div className={styles.spinner} />
				<span>Loading bets...</span>
			</div>
		);
	}

	return (
		<div className={styles.bets}>
			<header className={styles.header}>
				<div>
					<h1 className={styles.title}>Bets</h1>
					<p className={styles.subtitle}>View all bets from your players</p>
				</div>
			</header>

			{error && <div className={styles.error}>{error}</div>}

			{/* Filters */}
			<div className={styles.filterTabs}>
				{['all', 'wins', 'losses', 'dice', 'plinko'].map((f) => (
					<button key={f} className={`${styles.filterTab} ${filter === f ? styles.active : ''}`} onClick={() => setFilter(f)}>
						{f.charAt(0).toUpperCase() + f.slice(1)}
					</button>
				))}
			</div>

			{/* Bets Table */}
			<div className={styles.tableCard}>
				<table className={styles.table}>
					<thead>
						<tr>
							<th>Bet ID</th>
							<th>Player</th>
							<th>Game</th>
							<th>Amount</th>
							<th>Multiplier</th>
							<th>Payout</th>
							<th>Result</th>
							<th>Time</th>
						</tr>
					</thead>
					<tbody>
						{filteredBets.length ? (
							filteredBets.map((bet) => (
								<tr key={bet.id}>
									<td className={styles.betId}>{bet.id}</td>
									<td className={styles.playerId}>{bet.playerId}</td>
									<td>{bet.game}</td>
									<td>{bet.amount}</td>
									<td>{bet.multiplier.toFixed(2)}x</td>
									<td>{bet.payout}</td>
									<td>
										<span className={`${styles.badge} ${bet.won ? styles.badgeSuccess : styles.badgeDanger}`}>{bet.won ? 'Win' : 'Loss'}</span>
									</td>
									<td className={styles.timestamp}>{formatTime(bet.createdAt)}</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan={8} className={styles.emptyState}>
									No bets found
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}

function formatTime(timestamp: number): string {
	const date = new Date(timestamp);
	const now = new Date();
	const diffMs = now.getTime() - date.getTime();
	const diffMins = Math.floor(diffMs / 60000);

	if (diffMins < 1) return 'Just now';
	if (diffMins < 60) return `${diffMins}m ago`;

	const diffHours = Math.floor(diffMins / 60);
	if (diffHours < 24) return `${diffHours}h ago`;

	return date.toLocaleDateString();
}
